import { gql } from '@apollo/client';

const convertInteressentToAgent = gql`
  query ($variables: InteresentById!) {
    convertInteresentToAgent(input: $variables)
  }
`;

export default convertInteressentToAgent;
